import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function StorePurchase({ props }) {
  const { studentName, studentId, navigateToStorePayment, academicYearId } = props;
  const [searchQuery, setSearchQuery] = useState("");
  // Debounced mirror of searchQuery — filtering `allProducts` below depends
  // on this instead of searchQuery directly, so the filter doesn't re-run
  // on every keystroke.
  const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [product, setProduct] = useState([]);
  const [salesId, setSalesId] = useState(null);
  const [userId, setUserId] = useState();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("sales_details_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [validationErrors, setValidationErrors] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [salesDetails, setSalesDetails] = useState(null);
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [saleStatus, setSaleStatus] = useState([]);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [paidStatusId, setPaidStatusId] = useState(null);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [openProduct, setOpenProduct] = useState(false);
  const [error, setError] = useState(""); // Error message state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [allProducts, setAllProducts] = useState([]);

   const navigate = useNavigate();


  const handleProceed = () => {
    if (salesId) {
      navigateToStorePayment();
    }
    setOpenProduct(true);
    updateTotalPrice();
  };

  const handleCloseProduct = () => {
    setOpenProduct(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
          
        );
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);


  useEffect(() => {
  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresult`
      );
      if (!response.ok) throw new Error("Failed to fetch products");
      const data = await response.json();
      setAllProducts(data);
      setSearchResults([]); // initially show nothing
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchProducts();
}, []);

useEffect(() => {
  if (!appliedSearchQuery.trim()) {
    setSearchResults([]);
    return;
  }

  const searchTerms = appliedSearchQuery.toLowerCase().split(" ").filter(Boolean);

  const filtered = allProducts.filter((row) =>
    searchTerms.every(
      (term) =>
        (row.product_id &&
          row.product_id.toString().toLowerCase().includes(term)) ||
        (row.product_name &&
          row.product_name.toLowerCase().includes(term)) ||
        (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
        (row.attribute_name &&
          row.attribute_name.toLowerCase().includes(term)) ||
        (row.attribute_value &&
          row.attribute_value.toLowerCase().includes(term)) ||
        (row.price && row.price.toString().toLowerCase().includes(term)) ||
        (row.quantity && row.quantity.toString().toLowerCase().includes(term))
    )
  );

  setSearchResults(filtered);
}, [appliedSearchQuery, allProducts]);

// Product search is auto-filtering again (debounced), not Go-gated —
// filtering is entirely client-side over the already-fetched allProducts,
// so there's no DB call to save by waiting for an explicit submit; the
// debounce here just avoids re-running the filter on every single
// keystroke.
useEffect(() => {
  const handle = setTimeout(() => {
    setAppliedSearchQuery(searchQuery.trim());
  }, 300);
  return () => clearTimeout(handle);
}, [searchQuery]);

  useEffect(() => {
    getProduct();
  }, [studentId, academicYearId]);
  const getProduct = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/storepurchase/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials:'include',
          body: JSON.stringify({
            student_id: studentId,
            academic_year_id: academicYearId,
          }),
        }
      );

       // If the response status is 401, call signOut
       if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin")
        return; // Stop further execution
      }

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

      const data = await response.json();

      // Filter out products where the description is "Paid" or "Issued"
      const filteredData = data.filter(
       (item) => item.description !== "Paid" && item.description !== "Issued" && item.description !== "Refunded" && item.description !== "Partial Refund"
      );

      // Update state with filtered data
      setProduct(filteredData);
      setTableData(filteredData);

      // Handle sales ID and sales details only if there are valid products
      if (filteredData.length > 0) {
        setSalesId(filteredData[0].sales_id);
        setSalesDetails(filteredData[0].sales_details_id);
      } else {
        // Clear these states if no valid products remain
        setSalesId(null);
        setSalesDetails(null);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
         
        }
      );

   
   
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

      const data = await response.json();

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"
      const createdStatus =
        data.find((item) => item.description === "Created")?.sales_status_id ||
        null;
      const paidStatus =
        data.find((item) => item.description === "Paid")?.sales_status_id ||
        null;
      const issuedStatus =
        data.find((item) => item.description === "Issued")?.sales_status_id ||
        null;

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setCreatedStatusId(createdStatus);
      setPaidStatusId(paidStatus);
      setIssuedStatusId(issuedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  // Handle search input change
  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
   
  };

  // Handle product selection from search results
  const handleProductSelect = (product) => {
    // Check if the product is already in the table data
    const isAlreadyAdded = tableData.some(
      (item) => item.product_id === product.product_id
    );

    if (isAlreadyAdded) {
      // Show an error message for duplicate products
      setError("This product is already added.");
      setSnackbarOpen(true);
      console.log("Error: Duplicate product.");
      return; // Exit the function to avoid further execution
    }

    // Check if the product stock is zero or less
    if (product.quantity <= 0) {
      setError("This product is out of stock.");
      setSnackbarOpen(true);

      return; // Exit the function to avoid further execution
    }

    // Add the product to the table
    setTableData((prev) => [...prev, product]);
    setSearchQuery(""); // Clear search input
    setAppliedSearchQuery(""); // Clear applied search so results list hides
    setSearchResults([]); // Clear search results
    handleRowClick(product);
    setError(""); // Clear any existing error message
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const calculatedTotalPrice = product.reduce((accumulator, row) => {
      const rowTotalPrice = row.price * row.quantity;
      return accumulator + rowTotalPrice;
    }, 0);

    setTotalPrice(calculatedTotalPrice); // Update the state with the new total price
  }, [product]); // Recalculate when product changes

  // Handle row click to make the POST request
  const handleRowClick = async (product) => {
    try {
      // First, create a new sale entry
      const createResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/addSale`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            studentId,
            academicYearId,
            totalPrice,
            created_by: userId,
            sale_status_id: createdStatusId,
            salesId,
            staff_id: userId,
          }),
        }
      );

      const createResult = await createResponse.json();

      // Extract sales ID from the response
      const newSalesId = createResult.data.sales_id; // Assuming sales_id is returned in the response
      setSalesId(newSalesId); // Update state with new sales ID

      // Send sales details
      const detailsResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/addSaleDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: product.product_id,
            price: product.price,
            quantity: 1,
            sales_id: newSalesId, // Use the new sales ID
            created_by: userId,
          }),
        }
      );

      const detailsResult = await detailsResponse.json();

      getProduct();
    } catch (error) {
      console.error("Error:", error);
      // alert('An error occurred while processing the request.');
    }
  };

  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleRowDeleteClick = (sale) => {
    setMarkedForDelete((prev) => {
      const isAlreadyMarked = prev.includes(sale);
      const updatedMarkedForDelete = isAlreadyMarked
        ? prev.filter((id) => id !== sale) // Remove if already marked
        : [...prev, sale]; // Add if not marked

      // Recalculate total price excluding rows in updatedMarkedForDelete
      const calculatedTotalPrice = product.reduce((accumulator, row) => {
        if (!updatedMarkedForDelete.includes(row.sales_details_id)) {
          return accumulator + row.price * row.quantity;
        }
        return accumulator; // Exclude marked rows
      }, 0);

      setTotalPrice(calculatedTotalPrice); // Update totalPrice

      // Update selectedRow based on marking status
      if (isAlreadyMarked) {
        setSelectedRow(null); // Clear selection if unselecting
      } else {
        setSelectedRow({ sale }); // Update selection
      }

      return updatedMarkedForDelete; // Update markedForDelete state
    });
    console.log("markedForDelete", markedForDelete)
  };

  useEffect(() => {
    console.log("Updated marked for delete:", markedForDelete);
  }, [markedForDelete]);

  const handleBatchDelete = () => {
    
    setOpen(true);
    
  };



  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setMarkedForDelete("");
  };

  const handleDeleteConfirm = async () => {
    if (markedForDelete.length === 0) return; // Ensure there are selected rows

    try {
      // Iterate over each sales_details_id to delete them
      for (const sale of markedForDelete) {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/deleteSaleDetails`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            credentials:'include',
            body: JSON.stringify({ sales_details_id: sale }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete sale details."); // Handle errors
        }

        const result = await response.json();
      }
      // Refresh product data after deletion
      getProduct();

      // Clear the selected rows and close the dialog
      setMarkedForDelete([]);
      setOpen(false);
      setTimeout(() => {
        setSelectedRow(null);
      }, 1000);
    } catch (error) {
      console.error("Error deleting sale details:", error);
      setErrorMessage(error.message); // Display error message
    }
  };

  const updateTotalPrice = async () => {
    try {
      const calculatedTotalPrice = product.reduce((accumulator, row) => {
        const rowTotalPrice = row.price * row.quantity;
        return accumulator + rowTotalPrice;
      }, 0);

      const updateResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateSale`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials:'include',
          body: JSON.stringify({
            sales_id: salesId,
            totalPrice: calculatedTotalPrice, // Use freshly calculated total price
            updated_timestamp: new Date(),
            updated_by: userId,
          }),
        }
      );

      if (updateResponse.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin")
        return; // Stop further execution
      }
      const updateResult = await updateResponse.json();

      return updateResult; // Optionally return the result
    } catch (error) {
      console.error("Error while updating total price:", error);
      throw error;
    }
  };

  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    return product.slice().sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleQuantityChange = async (
    salesDetailsId,
    value,
    maxQuantity,
    productId
  ) => {
    // Parse the input to a number
    const numericValue = parseInt(value, 10);

    // Step 1: Validation checks
    if (value === "" || isNaN(numericValue)) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity is required and must be between 1 and ${maxQuantity}`,
      }));
      setSelectedQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: "",
      }));
      return;
    }

    if (numericValue < 1) {
      setValidationErrors((prev) => ({
        ...prev,
        // [salesDetailsId]: "Quantity must be at least 1.",
      }));
      return;
    }

    if (numericValue > maxQuantity) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity cannot exceed available stock.`,
      }));
      return;
    }

    // Step 2: Clear validation errors if all checks pass
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: null,
    }));

    // Step 3: Update the selected quantity in the local state
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: numericValue,
    }));

    try {
      // Update sales quantity in the backend
      const updateResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateQuantity`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials:'include',
          body: JSON.stringify({
            sales_details_id: salesDetailsId,
            quantity: numericValue,
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        }
      );

      if (!updateResponse.ok) {
        throw new Error("Failed to update sales data");
      }

      getProduct();
      setCurrentQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: numericValue,
      }));
      // updateTotalPrice();
    } catch (error) {
      console.error("Error during update:", error);
      alert(error.message);
    }
  };

  return (
    <div>
      <div className="main_title">Store Purchase of {studentName}</div>

      <div
        style={{
          margin: "20px 0",
          fontSize: 19,
          fontWeight: "bold",
          color: "#0A64A2",
        }}
      >
        Indent ID: {salesId}
      </div>

      <div className="store_purchase_search">
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="store_purchase_search1" >
            <TextField
              sx={{ minWidth: 700, marginBottom: "4px" }}
              label="Product Search"
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loading ? <CircularProgress size={18} /> : null}
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="sale-div">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                onClick={handleBatchDelete}
                className="sale-delete-btn"
              >
                Delete
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleProceed}
                className="sale-delete-btn"
              >
                Proceed To Payment
              </Button>
            </div>
          </div>
        </div>

        {/* Search Results List */}
          {appliedSearchQuery.trim() !== "" && searchResults.length > 0 && (
          <List
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0",
              width: 700,
            }}
          >
            {searchResults.map((product) => (
              <ListItem
                button
                key={product.id}
                onClick={() => handleProductSelect(product)}
              >
                <ListItemText primary={product.product_name} />
                <ListItemText primary={product.attribute_name} />
                <ListItemText primary={product.attribute_value} />
                <ListItemText primary={product.price} />
                <ListItemText primary={product.quantity} />
              </ListItem>
            ))}
          </List>
        )}
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
              <TableSortLabel
                  active={orderBy === "sales_details_id"}
                  direction={orderBy === "sales_details_id" ? order : "asc"}
                  onClick={() => handleSort("sales_details_id")}
                >
                Sl.No
                </TableSortLabel>
                </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "product_name"}
                  direction={orderBy === "product_name" ? order : "asc"}
                  onClick={() => handleSort("product_name")}
                >
                  Product Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_name"}
                  direction={orderBy === "attribute_name" ? order : "asc"}
                  onClick={() => handleSort("attribute_name")}
                >
                  Attribute Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_value"}
                  direction={orderBy === "attribute_value" ? order : "asc"}
                  onClick={() => handleSort("attribute_value")}
                >
                  Attribute Value{" "}
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "price"}
                  direction={orderBy === "price" ? order : "asc"}
                  onClick={() => handleSort("price")}
                >
                  Price
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity{" "}
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity In Stock
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "total_price"}
                  direction={orderBy === "total_price" ? order : "asc"}
                  onClick={() => handleSort("total_price")}
                >
                  Total Price{" "}
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const rowTotalPrice = row.price * row.quantity; // Calculate total price for current row
                return (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell
                      align="center"
                      component="th"
                      scope="row"
                      className="table-cell-border"
                    >
                      {row.sales_details_id}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.product_name}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_name}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_value}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.price}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      <div>
                        <input
                          type="number"
                          value={
                            selectedQuantity[row.sales_details_id] !== undefined
                              ? selectedQuantity[row.sales_details_id]
                              : row.quantity || 1 // Fallback to row.quantity if state is undefined
                          }
                          onChange={(e) =>
                            handleQuantityChange(
                              row.sales_details_id,
                              e.target.value,
                              row.stock,
                              row.product_id
                            )
                          }
                          style={{ width: "60px" }}
                          defaultValue={1}
                        />
                        {validationErrors[row.sales_details_id] && (
                          <div style={{ color: "red", marginTop: "5px" }}>
                            {validationErrors[row.sales_details_id]}
                          </div>
                        )}
                      </div>
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.stock}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {rowTotalPrice.toFixed(2)}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>{" "}
                    {/* Display calculated total price */}
                    <StyledTableCell
                      align="center"
                      style={{ lineHeight: "10px", padding: "5px" }}
                    >
                      <IconButton
                        color="black"
                        onClick={() =>
                          handleRowDeleteClick(row.sales_details_id)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}

            {/* Row to display total price */}
            <TableRow>
              <TableCell
                colSpan={9}
                align="right"
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  color: "#695a5a",
                  padding: "13px",
                  paddingRight: "70px",
                }}
              >
                Total Price : {totalPrice.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        style={{ backgroundColor: "#0A64A2", color: "#fff" }}
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={product.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* 
         

          {/* Delete Confirmation Dialog */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {markedForDelete.length>0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product before deleting."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          {markedForDelete.length>0 ? (
            <Button
              variant="contained"
              onClick={handleDeleteConfirm}
              className="no-btn"
            >
              Yes
            </Button>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            onClick={handleClose}
            autoFocus
            className="no-btn"
          >
            {markedForDelete.length>0 ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product Selection Dialog */}
      <Dialog
        open={openProduct}
        onClose={handleCloseProduct}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Please select product before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseProduct}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}
